import { Expose, Transform, Type } from 'class-transformer'
import { ChallengeUnit } from '@interfaces/UserMissionEnum'
import { ChallengeLevelType } from './ChallengeLevelType'

enum ChallengeCriteriaEnum {
  READER_CHAPTER = 'READER_CHAPTER',
  READER_SHELF = 'READER_SHELF',
  READER_FOLLOW = 'READER_FOLLOW',
  READER_BUY_CHAPTER = 'READER_BUY_CHAPTER',
  READER_BUY_ALL_CHAPTER = 'READER_BUY_ALL_CHAPTER',
  READER_DONATION = 'READER_DONATION',
  WRITER_VIEW = 'WRITER_VIEW',
  WRITER_LOVE = 'WRITER_LOVE',
  WRITER_BOOK = 'WRITER_BOOK',
}

const challengeCriteriaValue = {
  [ChallengeCriteriaEnum.READER_CHAPTER]: 'อ่านนิยาย',
  [ChallengeCriteriaEnum.READER_SHELF]: 'เพิ่มนิยายเข้าชั้น',
  [ChallengeCriteriaEnum.READER_FOLLOW]: 'ติดตามผู้ใช้งานอื่น',
  [ChallengeCriteriaEnum.READER_BUY_CHAPTER]: 'ซื้องานเขียนรายตอน',
  [ChallengeCriteriaEnum.READER_BUY_ALL_CHAPTER]: 'ซื้อนิยายครบทุกตอน',
  [ChallengeCriteriaEnum.READER_DONATION]: 'Donate ให้กับตัวละคร',
  [ChallengeCriteriaEnum.WRITER_VIEW]: 'มียอดวิว',
  [ChallengeCriteriaEnum.WRITER_LOVE]: 'มียอด Love',
  [ChallengeCriteriaEnum.WRITER_BOOK]: 'เขียนจบ',
}

export class UserMissionType {
  @Expose() id: number

  @Expose() title: string

  @Expose() description: string

  @Expose() iconUrl: string

  @Expose()
  @Transform(({ value }) =>
    value ? challengeCriteriaValue[value as ChallengeCriteriaEnum] : ''
  )
  criteria: string

  @Expose() unit: ChallengeUnit

  @Expose() currentLevel: number

  @Expose() currentLevelName: string

  @Expose() completed: number

  @Expose() nextLevel: number | null

  @Expose() nextLevelName: string

  @Expose() nextRemaining: number

  @Expose() nextTarget: number

  @Expose() maxLevel: number

  @Expose() previousTarget: number

  @Expose() missionLink: string

  @Expose()
  @Type(() => ChallengeLevelType)
  challengeLevels: ChallengeLevelType[]
}
